
import GwStatList from '~/patterns/organisms/stat-list/stat-list.vue';
import GwStatSlab from '~/patterns/atoms/stat-slab/stat-slab.vue';

export default {
    components: {
        GwStatList,
        GwStatSlab
    },
    computed: {
        isGladwell() {
            return this.$config.site.group === 'gladwell';
        },
        isHighberg() {
            return this.$config.site.group === 'highberg';
        },
        handle() {
            return this.$config.site.siteHandle;
        },
        showAiContent() {
            return this.isGladwell && (this.handle === 'en' || this.handle === 'nl' || this.handle === 'fr');
        },
        showCopilot() {
            return this.isGladwell && (this.handle === 'en' || this.handle === 'nl');
        },
        primaryStat() {
            return {
                label: this.isHighberg
                    ? this.$t('stat-list.recommended-rate')
                    : this.$t('stat-list.succesful-alumni'),
                data: this.isHighberg ? '95%' : '50K'
            };
        },
        secondaryStat() {
            if (this.isGladwell) {
                if (this.showCopilot) {
                    return {
                        label: 'AI. Learn it, Live it, Lead it',
                        image: {
                            src: '/logos/ai-native.png',
                            alt: 'AI native Logo',
                            width: 150,
                            height: 61
                        }
                    };
                } else if (this.handle === 'fr') {
                    return {
                        label: this.$t('stat-list.certified-trainers'),
                        data: '72'
                    };
                } else if (this.handle === 'de') {
                    return null;
                }
            }
            // Highberg
            return {
                label: this.$t('stat-list.organizations-participating'),
                data: '5K'
            };
        },
        tertiaryStat() {
            if (this.showCopilot) {
                return {
                    label: 'AI learning journey',
                    image: {
                        src: '/logos/copilot.png',
                        alt: 'Microsoft Copilot Logo',
                        height: 80
                    }
                };
            }
            if (this.handle === 'fr') {
                return {
                    label: 'AI. Learn it, Live it, Lead it',
                    image: {
                        src: '/logos/ai-native.png',
                        alt: 'AI native Logo',
                        width: 150,
                        height: 61
                    }
                };
            }

            return {
                label: this.isHighberg
                    ? this.$t('stat-list.participants-enrolled')
                    : this.$t('stat-list.certified-trainers'),
                data: this.isHighberg ? '50K+' : '72'
            };
        },
        quaternaryStat() {
            if (this.isGladwell) {
                return {
                    label: this.$t('stat-list.market-leader'),
                    image: {
                        src: '/logos/platinum-partner-logo.png',
                        alt: 'SAFE Logo',
                        width: 80,
                        height: 80
                    }
                };
            }
            return null;
        }
    }
};
